import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  getFirstDayOfMonth,
  getLasrDayOfMonth as getLastDayOfMonth,
  convertDate,
} from "../modules/helpers";

import "./suasapostas.css";

//Actions
import { selectConcursoScreen } from "../reducers/concurso/concursoActions";
import {
  betList,
  cleanApostas,
  recuperaApostas,
  closeApostaDetail,
} from "../reducers/relatorios/suasapostasActions";
import { repetirAposta } from "../reducers/repeticao/repeticaoActions";

import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";

import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "moment/locale/pt-br";

import Modal from "../common/form/modal";
import BilheteCard from "../common/bilheteCard/bilheteCard";

import PreTicketList from "../rifa/components/preTicketList";
import { getApostas, saveAposta } from "../utils/getApostas";
import { R$ } from "../rifa/utils/brl";
import { setApostasSimples, deleteApostaSimples, getFiltredApostaSimples } from "../utils/getApostasSimples";
import { verificaPagamentoPix } from "../reducers/carrinho/carrinhoActions";
import { deleteApostaPendente, getApostaPendente } from "../utils/getApostaPendente";
import { getFiltredPreTickets } from "../utils/getPreTickets";

import PixTicket from "../rifa/components/pixticket";

class Apostas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: getFirstDayOfMonth(),
      endDate: getLastDayOfMonth(),
      isEmpty: true,
      isDisabled: false,
      showAposta: false,
      apostasPendentes: [],
      apostasRealizadas: [],
      shownPendingQrCode: null
    };

    this.loadApostas = this.loadApostas.bind(this);
    this.renderApostasRows = this.renderApostasRows.bind(this);
    this.renderDateRange = this.renderDateRange.bind(this);
    this.handleStartDayChange = this.handleStartDayChange.bind(this);
    this.handleEndDayChange = this.handleEndDayChange.bind(this);
    this.fetchAposta = this.fetchAposta.bind(this);
    this.closeApostaDetail = this.closeApostaDetail.bind(this);
    this.repetirAposta = this.repetirAposta.bind(this);
    this.topRef = this.props.topRef || createRef(null);
  }

  componentWillMount() {
    this.props.cleanApostas([]);
    this.loadApostas();
  }

  componentDidUpdate() {
    let backdrop = document.getElementsByClassName("backdrop")[0];
    let modalDialog = document.getElementsByClassName("modal-dialog")[0];
    if (!backdrop) return;
    if (!modalDialog) return;

    // Se o usuário clicar no diálogo do modal ele não deve fechar há não ser que seja o botão de fechar
    modalDialog.onclick = (event) => {
      if (event.srcElement.id === "closeModalBtn") return;

      event.stopPropagation();
    };

    // Fecha modal caso clique fora do modal
    backdrop.onclick = () => {
      this.closeApostaDetail();
    };
  }

  loadApostas() {
    let apostasPagas = getApostas() || [];
    let apostaPendente = getApostaPendente(); //APOSTA  ATUAL
    let apostasPendentesList = getFiltredApostaSimples() || [];

    if (apostaPendente) {
      apostasPendentesList.push(apostaPendente);
    }

    let ticketsAnalisados = 0;
    let ticketsTotais = apostasPendentesList.length;
    let newApostasPendestesList = [...apostasPendentesList];

    const done = () => {
      for (const newTicket of apostasPagas) {
        const guid = newTicket.GUID;
        const index = newApostasPendestesList.findIndex(ap => ap.GUID === guid);
        if (index >= 0) newApostasPendestesList.splice(index, 1);

        deleteApostaSimples(guid);
        saveAposta(newTicket);
      }

      deleteApostaPendente();
      setApostasSimples(newApostasPendestesList);

      this.setState({
        apostasPendentes: newApostasPendestesList,
        apostasRealizadas: apostasPagas
      });
    }

    apostasPendentesList.forEach(ap => {
      verificaPagamentoPix(ap, (res) => {
        const newTicket = {...ap, detail: res.detail};

        if(res.tnyStatusPagamento === 1 && res.tnyStatusPreValidacao == 2) {
          // Grava aposta pix na memoria
          apostasPagas.push(newTicket);
        }

        if (newTicket.ticketAmount && newTicket.ticketAmount >= 2) {
          ticketsTotais += newTicket.ticketAmount - 1;
        }

        ticketsAnalisados ++;

        if (ticketsAnalisados >= ticketsTotais) {
          done();
        }
      });
    });

    if (!apostasPendentesList.length) {
      done();
    }
  }

  handleStartDayChange(selectedDay, modifiers, dayPickerInput) {
    const input = dayPickerInput.getInput();
    this.setState({
      startDate: selectedDay,
    });
  }

  handleEndDayChange(selectedDay, modifiers, dayPickerInput) {
    const input = dayPickerInput.getInput();
    this.setState({
      endDate: selectedDay,
    });
  }

  renderDateRange() {
    try {
      return (
        <React.Fragment>
          <div className="datepicker-wrapper">
            <DayPickerInput
              value={this.state.startDate}
              onDayChange={this.handleStartDayChange}
              format="L"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: this.state.startDate,
                localeUtils: MomentLocaleUtils,
                locale: "pt-br",
              }}
            />
            <div>{" à "}</div>
            <DayPickerInput
              value={this.state.endDate}
              onDayChange={this.handleEndDayChange}
              format="L"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: this.state.endDate,
                localeUtils: MomentLocaleUtils,
                locale: "pt-br",
              }}
            />
          </div>
          <button type="button" className="btn" onClick={this.loadApostas}>
            Ok
          </button>
        </React.Fragment>
      );
    } catch (error) {
      alert(error);
    }
  }

  fetchAposta(aposta) {
    this.props.recuperaApostas(this.props.objUser, aposta);
  }

  repetirAposta(aposta) {
    this.props.repetirAposta(this.props.objUser, aposta, (title,message)=>{this.props.toggleErrorModal(title, message)});
  }

  closeApostaDetail() {
    document.getElementsByTagName("body")[0].style.overflowY = "auto";
    this.props.closeApostaDetail();
  }

  renderApostasModal(ETicket) {
    document.getElementsByTagName("body")[0].style.overflowY = "hidden";
    /**
     * Visto que a estrutura dos dados Para a a geração do card de bilhete não são Uniformes
     * a longo da aplicação, se torna necessário mapear para uma estrutura aceita pelo componente
     */

    let arrJogo = ETicket.arrJogo.map((ap) => {
      //
      if ([555, 666, 1515].includes(ap.sntTipoJogo)) {
        return {
          arrNumeros: ap.vchNumero.match(/.{1,2}/g),
          valor: ap.numValor * 100,
          valorTotal: ap.numValor * 100,
          nome: ap.vchTipoJogo,
          possivelRetorno: ap.numValorPago,
        };
      } else {
        return {
          arrNumeros: ap.vchNumero instanceof Array ? ap.vchNumero : [ap.vchNumero],
          valor: ap.numValor * 100,
          valorTotal: ap.numValor * 100,
          nome: ap.vchTipoJogo,
          possivelRetorno: ap.numValor * 100,
          premio: ap.vchPremio,
          earned: ap.numPremio > 0 || ap.numValorPremioCota > 0,
          earnedFromQuota: ap.numValorPremioCota > 0
        };
      }
    });
    let arrResultado = ETicket.arrResultado;

    let Bilhete = {
      numValorApostas: ETicket.arrJogo[0].numValorApostas,
      vchNome: ETicket.arrJogo[0].vchTipoJogo,
      sntTipoJogo: ETicket.arrJogo[0].sntTipoJogo,
      sdtDataHora: ETicket.arrJogo[0].sdtDataHora.toLocaleString(), // Ex data: "2019-05-18 00:00"
      vchETicket: ETicket.arrJogo[0].vchETicket,
      sdtDataJogo: ETicket.arrJogo[0].sdtDataJogo,
      intNumeroPule: ETicket.arrJogo[0].intNumeroPule,
      arrJogo: arrJogo,
      arrResultado: arrResultado,
      vchExtracao: ETicket.arrJogo[0].vchDescricao,
      sdtDataAposta: convertDate(ETicket.arrJogo[0].sdtDataJogo),
      bitConcurso: ETicket.arrJogo[0].tipoJogo.bitConcurso,
      vcHorarioSorteio: ETicket.arrJogo[0].sdtConcurso.split(" ")[1],
      vchCodigoSeguranca: ETicket.arrJogo[0].vchCodigoSeguranca,
      chrSerial: this.props.objUser.chrSerial,
      numPremioTotal: ETicket.numPremioTotal,
      numValorPremioCotaTotal: ETicket.numValorPremioCotaTotal
    };

    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => this.closeApostaDetail()}
            >
              <span id="closeModalBtn" aria-hidden="true">
                X
              </span>
            </button>
          </div>
          <BilheteCard Bilhete={Bilhete} flatTop={true} />
        </div>
      </div>
    );
  }

  checkBetListLength(bitApurado = false){
    let apostas = bitApurado ? this.state.apostasRealizadas : this.state.apostasPendentes;
    if (apostas != undefined) {
      // .filter(ap=>ap.bitApurado == bitApurado)
      return apostas.length > 0;
    }

    return false;
  }

  renderApostasRows(bitApurado = false) {
    let apostas = bitApurado ? this.state.apostasRealizadas : this.state.apostasPendentes;

    const deleted = [];

    setTimeout(() => {
      for (const guid of deleted) {
        deleteApostaSimples(guid);
      }
    }, 0);

    if (apostas) {

      return apostas.map((ap) => {

        const somaPremio = (ap.detail && ap.detail.arrJogo && ap.detail.arrJogo.reduce((sum, j) => sum + (j.numPremio || 0), 0)) || 0;

        const isStillPayable = Date.now() - ap.timestamp <= 5 * 60 * 1000;
        const shouldShow = bitApurado || isStillPayable; // Date.now() - ap.timestamp <= 24 * 3600 * 1000;

        if (!shouldShow) {
          deleted.push(ap.GUID);
        }

        return !!shouldShow && <React.Fragment>
          <div
            key={ap.GUID}
            style={bitApurado ? undefined : {cursor: "default"}}
            onClick={() => bitApurado ? this.fetchAposta(ap) : isStillPayable ? this.setState({ shownPendingQrCode: ap }) : undefined}
            className={"ticket_card_container"}
          >
            <div className={"ticket_card_header"}>
              <h4><strong>{(bitApurado ? ap.detail.arrJogo[0].vchDescricao : ap.bilhetes.map(b => b.extraction).join(", ")) || ap.bilhetes[0].name}</strong></h4>
              <h4><strong>{`${ap.bilhetes[0].date}`}</strong></h4>
            </div>
            <div className={"ticket_card_body"}>
              <h4><strong>Valor: </strong>{R$(ap.bilhetes[0].value)}</h4>
              {!!bitApurado && !!somaPremio && <h4><strong>Prêmio: </strong>{R$(somaPremio)}</h4>}
            </div>

            <div className={"ticket_card_footer"} style={isStillPayable ? undefined : {cursor: "default"}}>
            {bitApurado ?
              <h4>{`Bilhete: ${ap.detail.vchETicket}`}</h4>
            :
              <h4>{isStillPayable ? `Realizar pagamento` : `Pagamento não efetuado`}</h4>
            }
            </div>
          </div>
        </React.Fragment>
      })
    } else return null;
  }

  render() {
    let apostasRows = this.renderApostasRows(false);
    let apostasRowsApurado = this.renderApostasRows(true);

    let loader = apostasRows ? null : (
      <div className="loader" style={{ marginTop: "0", alignSelf: 'center' }}></div>
    );

    let loaderApurado = apostasRowsApurado ? null : (
      <div className="loader" style={{ marginTop: "0", alignSelf: 'center' }}></div>
    );

    const isEmpty = !this.checkBetListLength(false) && !this.checkBetListLength(true) && !getFiltredPreTickets().length;

    return (
      <React.Fragment>
        <div className={"suas-apostas-container " + this.state.startDate} style={{marginTop:10}}>
        <section className="col-xs-12">
          <PreTicketList user={this.props.objUser} />
          {isEmpty && <React.Fragment>
            <h2 style={{textAlign:'center', fontWeight: 'bold'}}>Meus Tickets</h2>
            <p>Você não possui tickets.</p>
          </React.Fragment>}
        </section>

        {this.checkBetListLength(false) &&
        <section className="col-xs-12">
          <h2 style={{textAlign:'center', fontWeight: 'bold'}}>Meus Tickets</h2>
          <div className="box" style={{width:'100vw', border: 'none', background: 'none'}}>
            <div className="box-header header">
            </div>
            <div className="box-body">
              <div className="row">
                <div className="ticket_card_list">
                  {this.renderApostasRows(false)}
                </div>
              </div>
            </div>
          </div>
        </section>
        }
        <Modal show={this.props.showAposta}>
          {this.props.apostaAtual
            ? this.renderApostasModal(this.props.apostaAtual)
            : ""}
        </Modal>
        {
          !!this.state.shownPendingQrCode && 
            <PixTicket saved ticket={this.state.shownPendingQrCode} onClose={() => this.setState({ shownPendingQrCode: null })} toggleErrorModal={(...params) => {this.props.toggleErrorModal(...params)}} 
          />
        }
      </div>
      {loader}

      <div className={"suas-apostas-container " + this.state.startDate}>
      {this.checkBetListLength(true) &&
      <section className="col-xs-12">
        <h2 style={{textAlign:'center', fontWeight: 'bold'}}>Tickets Concluídos</h2>
        <div className="box" style={{width:'100vw', border: 'none', background: 'none'}}>
          {/* <div className="box-header header">
            <div className="datepicker-container">
              <h4>Data:</h4> {this.renderDateRange()}
            </div>
          </div> */}
          <div className="box-body">
            <div className="row">
              <div className="ticket_card_list">
                {this.renderApostasRows(true)}
              </div>
            </div>
          </div>
        </div>
      </section>
      }
      {loaderApurado}
      <Modal show={this.props.showAposta}>
        {this.props.apostaAtual
          ? this.renderApostasModal(this.props.apostaAtual)
          : ""}
      </Modal>
      </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  objUser: state.usuario.objUser,
  arrJogo: state.suasapostas.arrJogo,
  apostaAtual: state.suasapostas.apostaAtual,
  showAposta: state.suasapostas.showAposta,
  concursoType: state.concurso.concursoType,
  arrRepeticao: state.repeticao.arrAposta,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectConcursoScreen,
      betList,
      cleanApostas,
      recuperaApostas,
      closeApostaDetail,
      repetirAposta,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Apostas);



// WEBPACK FOOTER //
// ./src/relatorios/suasapostas.jsx